import { SourceBasedExpression } from './Expression.js';
export class StaticFunctionCallExpression extends SourceBasedExpression {
    constructor(source, fn, params) {
        super(source);
        this.fn = fn;
        this.params = (params || []).filter(param => !!param);
    }
    getFn() {
        return this.fn;
    }
    getParams() {
        return this.params;
    }
    evaluate(visitor, localVariables) {
        const source = visitor.getStatic(this.source);
        const params = this.getParams()
            .map(param => param.evaluate(visitor, localVariables));
        if (!source) {
            return false;
        }
        const fn = source[this.getFn()];
        const isFunction = typeof fn === 'function';
        if (isFunction) {
            return fn.apply(source, params);
        }
        else {
            throw new Error(`No static function found "${this.fn}" in "${this.source}"`);
        }
    }
}
//# sourceMappingURL=StaticFunctionCallExpression.js.map